import { FormSubmissionAnswer } from '../../../contracts/form-submission-answer.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { isSameData } from '../../dto/data-model-utils.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';
import { DayOfYear } from '../day-of-year.js';

export class DateTimeFormSubmissionAnswer extends FormSubmissionAnswer {
  static readonly TYPE_ID: string = 'c9a5b3d4e6f8a0b2c3d5e7f9a1b4c6d8';

  constructor(
    public readonly questionId: string,
    public readonly value: DayOfYear,
  ) {
    super();
  }

  get $typeId(): string {
    return DateTimeFormSubmissionAnswer.TYPE_ID;
  }

  static create(args: {
    questionId: string,
    value: DayOfYear,
  }): DateTimeFormSubmissionAnswer {
    return new DateTimeFormSubmissionAnswer(args.questionId, args.value);
  }

  static fromMap(context: SerializationContext, map: SerializedData): DateTimeFormSubmissionAnswer {
    return new DateTimeFormSubmissionAnswer(
        MapUtils.getString(map, 'questionId'),
        context.fromData<DayOfYear>(MapUtils.getRecord(map, 'value')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'questionId': this.questionId,
      'value': context.toData(this.value),
    };
  }

  clone(): this {
    return new DateTimeFormSubmissionAnswer(this.questionId, this.value.clone()) as this;
  }

  isSame(other: DateTimeFormSubmissionAnswer): boolean {
    if(other === this) {
      return true;
    }

    return other.questionId === this.questionId &&
      isSameData(other.value, this.value);
  }
}

export class DateTimeFormSubmissionAnswerBuilder extends DataModelBuilder<DateTimeFormSubmissionAnswer> {
  build(context: SerializationContext, map: SerializedData): DateTimeFormSubmissionAnswer {
    return DateTimeFormSubmissionAnswer.fromMap(context, map);
  }
}
